import { is_gen_2, real_id } from '../helpers/interface_helpers';
import { localReq } from './http';
import { unauthorisedRequests } from 'src/stores/device-runtime/firmware-ui';

export async function get_local_status(device, ip, skip_check = false) {
	const gen_2 = is_gen_2(device);
	if (ip.substring(0, 4) !== 'http') ip = `http://${ip}`;
	if (gen_2) {
		return await localReq(
			device,
			`${ip}/rpc/`,
			'post',
			{ id: Date.now(), method: 'Shelly.GetStatus', src: 'ShellyApp' },
			12000,
			false,
			false,
			skip_check,
		);
	}
	return await localReq(device, `${ip}/status`, 'get', {}, 12000, true, false, skip_check);
}

export async function get_local_settings(device, ip, skip_check = false) {
	const gen_2 = is_gen_2(device);
	if (ip.substring(0, 4) !== 'http') ip = `http://${ip}`;
	if (gen_2) {
		return await localReq(
			device,
			`${ip}/rpc/`,
			'post',
			{ id: Date.now(), method: 'Shelly.GetConfig', src: 'ShellyApp' },
			12000,
			false,
			false,
			skip_check,
		);
	}
	return await localReq(device, `${ip}/settings`, 'get', {}, 12000, true, false, skip_check);
}

/**
 * Fetches device identity from the LAN (Gen2: Shelly.GetDeviceInfo, Gen1: /shelly).
 *
 * @param device - Shelly device record
 * @param ip - Device IPv4 address (with or without `http://` prefix)
 * @param timeout - Request timeout in ms; defaults to 12000
 */
export async function get_local_device_info(device, ip, timeout = 12000) {
	const gen_2 = is_gen_2(device);
	if (ip.substring(0, 4) !== 'http') ip = `http://${ip}`;
	if (gen_2) {
		return await localReq(
			device,
			`${ip}/rpc/`,
			'post',
			{ id: Date.now(), method: 'Shelly.GetDeviceInfo', src: 'ShellyApp' },
			timeout,
			false,
			false,
		);
	}
	return await localReq(device, `${ip}/shelly`, 'get', {}, timeout, true, false);
}

export async function get_local_shelly_info(device, ip) {
	// we need to skip the check for the device inclusion process
	let skip_check = true;
	const gen_2 = is_gen_2(device);
	const data = gen_2
		? {
				id: Date.now(),
				method: 'Shelly.GetDeviceInfo',
				src: 'ShellyApp',
			}
		: {};
	const url = gen_2 ? 'rpc/' : 'shelly';
	const method = gen_2 ? 'post' : 'get';
	if (ip.substring(0, 4) != 'http') ip = `http://${ip}`;
	return await localReq(device, `${ip}/${url}`, method, data, 12000, !gen_2, false, skip_check);
}

export async function enable_cloud(device, ip) {
	let res;
	try {
		if (is_gen_2(device)) {
			res = await localReq(device, `http://${ip}/rpc/`, 'post', {
				id: Date.now(),
				method: 'Cloud.SetConfig',
				params: { config: { enable: true } },
				src: 'ShellyApp',
			});
		} else {
			res = await localReq(
				device,
				`http://${ip}/settings/cloud`,
				'post',
				{ enabled: 1 },
				20000,
				true,
			);
		}
	} catch (error) {
		res = error;
	}

	return res;
}

/**
 * Makes a request to trigger 401 and capture www-authenticate header
 * This is used when we detect auth_en: true from DeviceInfo but don't have the auth header yet
 */
export async function trigger401ToGetAuthHeader(device, ip) {
	const gen_2 = is_gen_2(device);
	const id = real_id(device.id);

	if (ip.substring(0, 4) != 'http') ip = `http://${ip}`;

	let url, method, payload;

	if (gen_2) {
		url = `${ip}/rpc/`;
		method = 'post';
		payload = {
			id: Date.now(),
			method: 'Shelly.GetStatus',
			src: 'ShellyApp',
		};
	} else {
		url = `${ip}/status`;
		method = 'get';
		payload = {};
	}

	unauthorisedRequests.update((d) => {
		return {
			...d,
			[id]: {
				responseHeaders: null,
				payload: payload,
				url: url,
			},
		};
	});

	try {
		const fetchOptions = {
			method: method.toUpperCase(),
			headers: {
				'Content-Type': 'application/json',
			},
			body: method === 'post' ? JSON.stringify(payload) : undefined,
		};

		const response = await fetch(url, fetchOptions);

		if (response.status === 401) {
			const responseHeaders = response.headers.get('www-authenticate');

			if (responseHeaders) {
				unauthorisedRequests.update((d) => {
					return {
						...d,
						[id]: {
							responseHeaders: responseHeaders,
							payload: payload,
							url: url,
						},
					};
				});
				return responseHeaders;
			}
		}

		console.warn('trigger401ToGetAuthHeader: Expected 401 but got status', response);
		return null;
	} catch (error) {
		console.warn('trigger401ToGetAuthHeader: Fetch failed', error);
		return null;
	}
}
